import { ICancellationNavigationState } from 'v3/data/store/cancellationNavigation/types';

export const initialCancellationNavigationState: ICancellationNavigationState = {
  currentCancelationState: null,
  isCancellationDialogOpen: false,
  isCancellationErrorDialogOpen: false,
  isRefundConflictDialogOpen: false,
};
